<template>
    <div class='home_wrap'>
        <div class="top_img">
        <!-- <Header v-show="this.$route.path != '/404'" ></Header> -->
            <div class="main_tip">MS数据资源库</div>
            <div class="mian_con">数据全面且覆盖面广泛，包括金融财经、行业产业以及创新事件数据，利用互联网技术实时更新，数据种类持续增加，随时开放下载，实现教学与科研结合。</div>
            <div class="main_btn flex-around">
                <div class="btn_left  btn" @click="enterPath(1)">数据资源</div>
                <div class="btn_right btn" @click="enterPath(2)">数据API文档</div>
            </div>
        </div>
        <div class="mid_wrap flex-around">
            <div class="mid_wrap_left">
                <div class="left_top"><span class="iconfont icon-xitongxinxi mr20"></span><span>数据资源</span></div>
                <div class="left_main" v-for="(item,index) in sourcData"><span :class="item.icon" class="mr20 fonsize46" ></span><span :class="{mrl10:index==1}">{{item.title}}</span></div>
                <div class="enter1" @click="enterPath(1)">点击进入 ></div>
            </div>
            <div class="mid_wrap_right">
                <img src="../../assets/img/tips_img1.png" alt="" width="100%">
            </div>
        </div>
        <div class="but_img flex-center">
            <div class="bun_right flex-around">
                <div class="mid_wrap_right"><img src="../../assets/img/tips_img2.png" alt="" width="100%"></div>
                <div class="mid_wrap_left">
                <div class="left_top"><span class="iconfont icon-wendang fonsize32 mr20"></span><span>数据API文档</span></div>
                <div class="left_main" v-for="(item,index) in sourcAPI"><span :class="item.icon" class="mr20 fonsize32"></span><span >{{item.title}}</span></div>
                <div class="enter1" @click="enterPath(2)">点击进入 ></div>
                </div>
            </div>
        </div>
        <div class="sorce_list">
            <div class="list_title">数据资源使用方式</div>
            <div class="list_top flex-around">
                <div class="list_item" v-for="(item,index) in sourceList1"><div class=" mab20 img"><span :class="item.icon" class="mr10 fonsize40"></span></div><div class="font20">{{item.title}}</div></div>
            </div>
            <div class="list_btu flex-around">
                <div class="list_item" v-for="(item,index) in sourceList2"><div class=" mab20 img"><span :class="item.icon" class="mr10 fonsize40"></span></div><div class="font20">{{item.title}}</div></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      sourcData:[
        {
          icon:`iconfont icon-cangku_kucunxiangqing`,
          title:'数据来源丰富-证券期货交易所、行业协会、院校研究机构等'
        },
        {
          icon:`iconfont icon-tandem-full`,
          title:'核心算法矫正-分析异常数据源、不同数据源间交叉对比'
        },
        {
          icon:`iconfont icon-shuangxiangduibi `,
          title:'数据双向生产-用户二次生产增加价值'
        }
      ],
      sourcAPI:[
        {
          icon:`iconfont icon-danhangchenlie `,
          // title:'文档清晰罗列平台所有可用数据'
          title:'清晰罗列平台所有可用接口数据'
        },
        {
          icon:`iconfont icon-chazhao  `,
          title:'支持用户搜索所需数据,快速查找数据所在位置'
        },
        {
          icon:`iconfont icon-shanxingtubeifen2  `,
          // title:'大幅度缩短数据查找时间,提升学习、科研效率'
          title:'每条数据包含接口信息、数据描述、数据类型等'
        }
      ],
      sourceList1:[
        {
          icon:`iconfont icon-jichugongneng   `,
          title:'平台对数据资源提供清晰分类，用户可点击不同类别查看数据子分类。'
        },
        {
          icon:`iconfont icon-caiyouduo_hemaixiangqing-fanganxiangqing   `,
          title:'用户可在下载数据前阅读数据简介，帮助理解数据内容。'
        }
      ],
      sourceList2:[
        {
          icon:`iconfont icon-shijian1   `,
          title:'根据个人需求灵活选择数据下载时间区间。'
        },
        {
          icon:`iconfont icon-xianxingsousuo   `,
          title:'输入数据关键词快速查找特定种类数据。'
        },
        {
          icon:`iconfont icon-icon2   `,
          title:'部分数据可在下载前对数据计算方式进行调整。'
        }
      ]
    }
  },
created(){
},
methods:{
    // 路由跳转
    enterPath(item){
        switch(item){
            case 1:
                this.$router.push('/dataSource')
            break;
            // 新窗口打开API文档
            case 2:
                let url = this.$router.resolve({
                        name: 'dataApi'
                    })
                window.open(url.href,'_blank')
            break;
        }
    }
}
}
</script> 

<style lang='scss' scoped>
.mrl10{
    margin-left: 10px;
}
.icon-xitongxinxi{
    font-size: 32px;
    color: #5377F7;
}
.icon-tandem-full{
    font-size: 32px !important;
}
.enter1:hover{
    opacity: 0.8;
    cursor: pointer;
}
.home_wrap{
        width: 100%;
    .top_img{
            width: 100%;
            height: 580px;
            color: #fff;
            background: url(../../assets/img/top_img1.png) 0 0/100% 100% no-repeat;
        .main_tip{
            text-align: center;
            font-size: 30px;
            font-weight: bold;
            position: relative;
            top: 170px;
        }
        .mian_con{
            width: 60%;
            margin-left: 20%;
            text-align: center;
            font-size: 24px;
            margin-top: 220px;
        }
        .main_btn{
            width: 24%;
            height: 80px;
            margin-top: 160px;
            margin-left: 38%;
            .btn{
                width: 35%;
                height: 50px;
                line-height: 50px;
                text-align: center;
                font-size: 24px;
                font-weight: bold;
            }
            .btn:hover{
                cursor: pointer;
                background: #9431FF;
                border: 2px solid #FFFFFF;
                box-shadow: 0px 2px 12px #D789FF;
                border-radius: 31px;
            }
        }
    }
    .mid_wrap{
        width: 100%;
        padding: 100px 0 50px 0;
        // background: rgb(207, 187, 172);
        .mid_wrap_left{
            width: 40%;
            text-align: left;
        .left_top{
            font-size: 30px;
            font-weight: bold;
            margin-bottom: 60px;
        }
        .left_main{
            font-size: 24px;
            margin-bottom: 30px;
        }
        .enter1{
            font-size: 20px;
            font-weight: bold;
            color: #5277F7;
            margin-top: 60px;
        }
        }
        .mid_wrap_right{
            width: 40%;
        }
    }
    .but_img{
            width: 100%;
            height: 626px;
            background: url(../../assets/img/button_img1.png) 0 0/100% 100% no-repeat;
            color: #fff;
        .bun_right{
            width: 70%;
            height: 70%;
            // border: 2px solid #fff;
            margin-left: 28%;
        .mid_wrap_left{
            width: 45%;
            .left_top{
                font-size: 30px;
                font-weight: bold;
                margin-bottom: 50px;
            }
            .left_main{
                font-size: 24px;
                margin-bottom: 30px;
            }
            .enter1{
                font-size: 20px;
                font-weight: bold;
                margin-top: 50px;
            }
        }
        .mid_wrap_right{
            width: 50%;
        }
    }
        
    }
    .sorce_list{
            width: 100%;
            padding-bottom: 120px;
        .list_title{
            width: 200px;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            border-bottom:5px solid #5277F7;
            margin-left: calc(50% - 100px);
            margin-top: 50px;
            padding-bottom: 10px;
        }
        .list_top{
            width: 40%;
            margin:100px 30%;
        .list_item{
            width: 30%;
            padding: 80px 30px;
            background: #fff;
            box-shadow: 0px 3px 4px #C9C9C9;
            border-radius: 4px;
            .img{
                background: url(../../assets/img/Bubble.png) 0 0/100% 100% no-repeat;
                width: 126px;
                height: 105px;
                line-height: 105px;
                text-align: center;
                font-size: 30px;
                margin-left: calc(50% - 64px);
            }
        }
    }
        .list_btu{
            width: 60%;
            margin: 60px 20%;
        //  background: chartreuse;
            .list_item{
                width: 20%;
                padding: 80px 30px;
                background: #fff;
                box-shadow: 0px 3px 4px #C9C9C9;
                border-radius: 4px;
                .img{
                    background: url(../../assets/img/Bubble.png) 0 0/100% 100% no-repeat;
                    width: 126px;
                    height: 105px;
                    line-height: 105px;
                    text-align: center;
                    font-size: 30px;
                    margin-left: calc(50% - 64px);
                }
            }
        }
    }
}
</style>